import { i18n } from '@lingui/core'
import styled, { useTheme } from 'styled-components'

import { Flex } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { globalDefinitions } from '@/defined-translations'

import type { TimelineActivity } from '@/modules/timeline/components/timeline/Timeline'

export const HealthProfileCard = ({ meta }: TimelineActivity) => {
  const theme = useTheme()

  if (!meta?.questionnaireSlug) {
    return null
  }

  const definitionId = `change_${meta.questionnaireSlug}` as keyof typeof globalDefinitions
  const text = i18n._(globalDefinitions[definitionId] as string)

  return (
    <Flex justifyContent='space-between' alignItems='center' gap={8} style={{ marginTop: 4, marginBottom: 4 }}>
      <StLine />
      <Span type='BodySmallRegular' color={theme.Colors.Neutrals.Dark}>
        {text}
      </Span>
      <StLine />
    </Flex>
  )
}

const StLine = styled.div`
  flex-grow: 1;
  height: 1px;
  background-color: ${({ theme }) => theme.Colors.Neutrals.Light};
`
